import styles from './Projects.module.css';

import ProjectCard from './ProjectCard';
import projectData from '../../data/projects.json';

import React from "react";

function Projects() {
    return (
        <section className={styles.container} id="projects">
            <h2 className={styles.title}>Projects</h2>
            <div className={styles.projects}>
                {projectData.map((project, id) => {
                    return <ProjectCard key={id} projectInfo={project} />;
                })}
            </div>
        </section>
    )
}

export default Projects;